import { defineStore } from "pinia";

export const useUiStore = defineStore("ui", {
    state: () => ({
        snackbar: {
            show: false,
            message: '',
            color: 'success',
        }
    }),

    actions: {
        showSuccess(message) {
            this.snackbar = { show: true, message, color: 'success' };
        },
        showError(message) {
            this.snackbar = { show: true, message, color: 'error' };
        },
        showInfo(message) {
            this.snackbar = { show: true, message, color: 'info' };
        },
    }
});
